<template>
	<v-row justify="center">
		<v-col cols="12" md="8" lg="6">
			<v-card class="elevation-2">
				<v-card-title class="headline">Mijn profiel</v-card-title>
				<v-card-text v-if="user">
					<v-simple-table dense>
						<tbody>
							<tr>
								<td class="font-weight-medium">Naam</td>
								<td>{{ displayName }}</td>
							</tr>
							<tr>
								<td class="font-weight-medium">OSBOD e-mail</td>
								<td>{{ user.osbod_email || "—" }}</td>
							</tr>
							<tr>
								<td class="font-weight-medium">Studie</td>
								<td>{{ studyName }}</td>
							</tr>
							<tr>
								<td class="font-weight-medium">Schooljaar</td>
								<td>{{ schoolyearName }}</td>
							</tr>
							<tr>
								<td class="font-weight-medium">Klas</td>
								<td>{{ className }}</td>
							</tr>
							<tr>
								<td class="font-weight-medium">Leerjaar</td>
								<td>{{ gradeName }}</td>
							</tr>
						</tbody>
					</v-simple-table>
				</v-card-text>
				<v-card-text v-else>
					<p>Geen studentgegevens beschikbaar.</p>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: "profile",
	computed: {
		user() {
			return (
				this.$store.getters.getUser ||
				JSON.parse(localStorage.getItem("user") || "null")
			);
		},
		displayName() {
			if (!this.user) return "";
			if (this.user.display_name) return this.user.display_name;
			return [this.user.firstname, this.user.middlename, this.user.surname]
				.filter(Boolean)
				.join(" ");
		},
		studyName() {
			if (!this.user) return "—";
			if (this.user.current_class && this.user.current_class.tbl_sys_study) {
				return this.user.current_class.tbl_sys_study.name || "—";
			}
			return (this.user.tbl_sys_study && this.user.tbl_sys_study.name) || "—";
		},
		schoolyearName() {
			if (!this.user) return "—";
			if (this.user.current_class && this.user.current_class.tbl_sys_schoolyear) {
				return this.user.current_class.tbl_sys_schoolyear.name || "—";
			}
			return (
				(this.user.tbl_sys_schoolyear && this.user.tbl_sys_schoolyear.name) || "—"
			);
		},
		className() {
			if (
				!this.user ||
				!this.user.current_class ||
				!this.user.current_class.tbl_sys_class
			) {
				return "—";
			}
			return this.user.current_class.tbl_sys_class.name || "—";
		},
		gradeName() {
			if (!this.user || !this.user.tbl_sys_grade) return "—";
			return this.user.tbl_sys_grade.name || "—";
		}
	}
};
</script>
